export default "__VITE_ASSET__Bw9w512U__$_?v=2__"